const constants = {
  baseURL: "https://web-api.dev.grind.co.uk/v1",
  stripeKey: "pk_test_zQOLj4FvRBqsuIM4HGVYyWlv",
  googleKey: "AIzaSyDlOdzEosDz34FuRNXiRzaDTt8JkBbXk8o",
  bugsnagReleaseStage: "development",
  multipassUrl:
    "https://the-grind-website-eur.myshopify.com/en-gb/account/login/multipass/"
};

export default constants;
